const data = [
  {
    label: `Security`,
    id: `security`,
    href: `security`,
  },
  {
    label: `Data Privacy`,
    id: `data-privacy`,
    href: `data-privacy`,
  },
  {
    label: `Compliance`,
    id: `compliance`,
    href: `compliance`,
  },
  {
    label: `Regional Segment`,
    id: `regional-segment`,
    href: `regional-segment`,
  },
  {
    label: `Infrastructure`,
    id: `infrastructure`,
    href: `infrastructure`,
  },
]

export default data
